import React from 'react';
import './TextInput.css';

export type InputSize = 'sm' | 'md' | 'lg';

export interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /** Size preset. Default: 'md' */
  size?: InputSize;
  /** Sol taraf ikon (Mail, Lock, Search vs.) */
  leadingIcon?: React.ReactNode;
  /** Sağ taraf element (şifre toggle butonu vs.) */
  trailingElement?: React.ReactNode;
  /** Hata durumu — kırmızı border + shadow */
  error?: boolean;
  /** textarea olarak render et */
  as?: 'input' | 'textarea';
  /** textarea satır sayısı */
  rows?: number;
  /** wrapper className */
  wrapperClassName?: string;
}

export const TextInput = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  TextInputProps
>(function TextInput(
  {
    size = 'md',
    leadingIcon,
    trailingElement,
    error = false,
    as = 'input',
    rows,
    wrapperClassName,
    className,
    disabled,
    ...rest
  },
  ref
) {
  const wrapperClasses = [
    'text-input-wrapper',
    `text-input-wrapper--${size}`,
    error && 'text-input-wrapper--error',
    disabled && 'text-input-wrapper--disabled',
    leadingIcon && 'text-input-wrapper--has-icon',
    trailingElement && 'text-input-wrapper--has-trailing',
    wrapperClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const fieldClasses = [
    'text-input-field',
    as === 'textarea' && 'text-input-field--textarea',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {leadingIcon && (
        <span className="text-input-icon">{leadingIcon}</span>
      )}

      {as === 'textarea' ? (
        <textarea
          ref={ref as React.Ref<HTMLTextAreaElement>}
          className={fieldClasses}
          disabled={disabled}
          rows={rows}
          {...(rest as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          ref={ref as React.Ref<HTMLInputElement>}
          className={fieldClasses}
          disabled={disabled}
          {...rest}
        />
      )}

      {trailingElement && (
        <span className="text-input-trailing">{trailingElement}</span>
      )}
    </div>
  );
});
